import React, { FC, useCallback } from 'react';
import { ModalWrapper } from 'components/modals/ModalWrapper';
import { Carousel } from './components/Carousel';
import { RunnerType } from 'adapters/repositories/typeDefinition';

export const usePracticeOnboardingModal = (runner: RunnerType | undefined) => {
  const [open, setOpen] = React.useState(false);

  const toggleModalOpen = () => {
    setOpen(!open);
  };

  const forceModalOpen = useCallback((openOrClose: boolean) => {
    setOpen(openOrClose);
  }, []);

  return {
    forceModalOpen: forceModalOpen,
    toggleModalOpen: toggleModalOpen,
    OnboardModal:
      (!!runner && (
        <OnboardModal
          isModalOpen={open}
          setIsModalOpen={setOpen}
          runner={runner}
        />
      )) ||
      null,
  };
};

type Props = {
  isModalOpen: boolean;
  setIsModalOpen: React.Dispatch<React.SetStateAction<boolean>>;
  runner: RunnerType;
};

const OnboardModal: FC<Props> = ({ isModalOpen, setIsModalOpen, runner }) => {
  const handleClose = useCallback(() => {
    setIsModalOpen(false);
    localStorage.setItem(String(runner.id), 'beforeChallenge');
  }, [runner]);

  return (
    <ModalWrapper isModalOpen={isModalOpen} setIsModalOpen={setIsModalOpen}>
      <div>
        <Carousel handleClose={handleClose} runner={runner} />
      </div>
    </ModalWrapper>
  );
};
